import React from "react";
import { FLEET } from "../data/fleet";
import { Link } from "react-router-dom";
import { Users, Briefcase, Star } from "lucide-react";
import { SITE } from "../data/site";

export default function Fleet() {
  return (
    <div className="pt-32 pb-24 bg-[#050505] min-h-screen" data-testid="fleet-page">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <div className="label-eyebrow mb-3">Our Vehicles</div>
          <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight">
            A pristine, executive-grade luxury fleet.
          </h1>
          <p className="text-white/65 mt-5 leading-relaxed">
            From Mercedes-Benz S-Class sedans and Cadillac Escalade SUVs to Sprinter vans, stretch limousines,
            and full motor coaches — every vehicle in our fleet is maintained to flagship standards.
          </p>
        </div>

        <div className="space-y-8">
          {FLEET.map((v, i) => (
            <div
              key={v.name}
              className={`grid md:grid-cols-12 gap-6 lux-card overflow-hidden ${i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`}
              data-testid={`fleet-${v.name.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <div className={`md:col-span-6 h-72 md:h-auto overflow-hidden ${v.whiteBg ? "fleet-photo-light" : "bg-black"}`}>
                <img
                  src={v.image}
                  alt={v.name}
                  className={`w-full h-full ${v.whiteBg ? "object-contain p-4 mix-blend-multiply" : "object-cover"}`}
                />
              </div>
              <div className="md:col-span-6 p-8 md:p-10 flex flex-col justify-center">
                <div className="label-eyebrow mb-2">0{i + 1} · Fleet</div>
                <h3 className="font-display text-3xl text-white mb-3">{v.name}</h3>
                <div className="flex items-center gap-4 text-sm text-white/65 mb-4">
                  <span className="flex items-center gap-1.5"><Users size={14} className="text-[#d4af6a]" />{v.capacity}</span>
                </div>
                <p className="text-white/65 text-sm leading-relaxed mb-4"><strong className="text-white/85">Models:</strong> {v.examples}</p>
                <p className="text-white/65 text-sm leading-relaxed mb-6"><strong className="text-white/85">Perfect for:</strong> {v.perfect}</p>
                <div className="flex gap-3">
                  <Link to="/book" className="btn-accent text-xs">Book This Vehicle</Link>
                  <Link to="/contact" className="btn-outline text-xs">Get Quote</Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
